module.exports = __webpack_public_path__ + "img/curve-4-3.3e59ed66.svg";